import React, { useContext, useState } from 'react';
import SearchField from '../global-components/searchField';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SelectOwnerDropdown from '../global-components/SelectOwnerDropdown';
import AddButton from '../global-components/AddButton';
import ability from '../../utils/ability';
import { AbilityContext } from '../../context/AbilityContext';

interface Props {
  selectedUserEmail: any;
  setSelectedUserEmail: any;
  handleFilter: any;
  handleSearchField: any;
  setSearchQuery: any;
  isAdmin?: boolean;
  isVendor?: boolean;
  fileName?: any;
  handleToggleChange?: any;
  setHandleToggleChange?: any;
  searchTerm?: any;
  clickHandler?: any;
  startDate?: any;
  setStartDate?: any;
  endDate?: any;
  setEndDate?: any;
}
function FilterNavProject({
  selectedUserEmail,
  setSelectedUserEmail,
  handleFilter,
  handleSearchField,
  setSearchQuery,
  isAdmin,
  isVendor,
  fileName,
  setHandleToggleChange,
  handleToggleChange,
  searchTerm,
  clickHandler,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: Props) {
  const ability = useContext(AbilityContext);

  return (
    <>
      <div className='w-100 mb-4 d-flex gap-3'>
        <div className='w-100'>
          <label htmlFor='user' className='form-label labelText'>
            Owner
          </label>
          <SelectOwnerDropdown
            setSelectedUserName={setSelectedUserEmail}
            selectedUserName={selectedUserEmail}
            setHandleToggleChange={setHandleToggleChange}
          />
        </div>
        <div className='w-100 my-auto'>
          <label className='dropdown-label' id={'startDate'}>
            Start Date
          </label>
          <DatePicker
            id={'startDate'}
            selected={startDate ? new Date(startDate) : null}
            onChange={(date: any) => {
              if (!date) return setStartDate(null);
              setStartDate(
                new Date(date?.getTime() - date?.getTimezoneOffset() * 60000)
                  ?.toISOString()
                  ?.split('T')[0]
              );
              setHandleToggleChange && setHandleToggleChange(true);
            }}
            className={`form-control  ubbe-input ${
              startDate ? 'highlighted-border' : ''
            }`}
            placeholderText={'Please Select'}
            dateFormat='yyyy-MM-dd'
            autoComplete='off'
            // icon={calendarIcon}
            showIcon={true}
            calendarIconClassname='calendarIcon'
          />
        </div>
        <div className='w-100 my-auto'>
          <label className='dropdown-label' id={'endDate'}>
            End Date
          </label>
          <DatePicker
            id={'endDate'}
            selected={endDate ? new Date(endDate) : null}
            onChange={(date: any) => {
              if (!date) return setEndDate(null);
              setEndDate(
                new Date(date?.getTime() - date?.getTimezoneOffset() * 60000)
                  ?.toISOString()
                  ?.split('T')[0]
              );
              setHandleToggleChange && setHandleToggleChange(true);
            }}
            className={`form-control  ubbe-input ${
              endDate ? 'highlighted-border' : ''
            }`}
            placeholderText={'Please Select'}
            dateFormat='yyyy-MM-dd'
            autoComplete='off'
            // icon={calendarIcon}
            showIcon={true}
            calendarIconClassname='calendarIcon'
          />
        </div>
        <div className='d-flex flex-column'>
          <button
            type='button'
            style={{ width: '154px' }}
            data-testid='filter-button'
            className={
              handleToggleChange
                ? 'active-filter mt-auto '
                : 'mt-auto  disable-filter'
            }
            onClick={() => {
              handleToggleChange && handleFilter();
            }}
          >
            Filter
          </button>
        </div>
      </div>
      <div className='d-flex  mb-4 justify-content-between align-items-center'>
        <div className='d-flexformobile gap-4 align-items-center '>
          {fileName && (
            <div className=''>
              <div className='row '>
                <div className='col-sm-12 my-auto'>
                  <h1 className='rates__title'>{fileName}</h1>
                </div>
              </div>
            </div>
          )}
          <div className=''>
            <div className='input-group '>
              <SearchField
                id={'search-field'}
                placeHolder={'Search here'}
                className={'form-control ubbe-input w-100 width-input'}
                handleSearchField={handleSearchField}
                setSearchQuery={setSearchQuery}
                searchText={searchTerm}
              />
            </div>
          </div>
        </div>
        <div>
          {ability.can('create', 'Project') && (
            <AddButton clickHandler={clickHandler} />
          )}
        </div>
      </div>
    </>
  );
}

export default FilterNavProject;
